
<template>
  <div class="mw-process-manage">
    <mw-dialog title="管理流程版本" size="small_large" :appendToBody="true" ref="flowVersionDialog" :footerButton="footerButton">
      <div class="mw-process-manage">
      <ul class="process-list mw-process-manage">
        <li v-for="(item,index) in processList"
            :key="index"
            @click="selectVersion(item.version,item.status)"
            @dblclick="editProcess"
            :class="{list_bg:(item.version!=selVersion),active:(item.version==selVersion)}">
          <span v-text="item.name"></span>(<span v-text="item.version"></span>.0)
          <span v-if="item.status==0" class="pull-right">设计</span>
          <span v-else-if="item.status==1" class="pull-right">启用</span>
          <span v-else class="pull-right">历史</span>
        </li>
      </ul>
      </div>
    </mw-dialog>
    <mw-dialog title="管理回收站" size="small_large" :appendToBody="true" ref="flowRecycleBinDialog" :footerButton="recycleBinFooterButton">
      <ul class="process-list">
        <li v-for="(item,index) in processDelList"
            :key="index"
            @click="selectDelVersion(item.version,item.status)"
            :class="{list_bg:(item.version!=selDelVersion),active:(item.version==selDelVersion)}">
          <span v-text="item.name"></span>(<span v-text="item.version"></span>.0)
        </li>
      </ul>
    </mw-dialog>

    <div class="flow-edit-top">
      <div class="flow-des">
        <!--<div style="display:inline-block">
          <el-button @click="createNewFlow"><i class="fa fa-file-text-o"></i>新建流程</el-button>
          <el-button @click="relateFlow"><i class="fa fa-file-text-o"></i>关联流程</el-button>
        </div>-->
        <div style="display:inline-block;padding-left:10px;font-size: 14px;">
          <span v-if="curStatus==0">设计</span>
          <span v-else-if="curStatus==1">启用</span>
          <span v-else>历史</span>(<span v-text="curVersion"></span>.0)
          <span style="padding-left:20px;" v-if="relationFlowName">关联流程:{{relationFlowName}}
            <el-button type="primary" @click="delRelatedFlow">取消关联</el-button>
          </span>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="flowbar">
        <el-button v-if="!relationFlowName" type="primary" @click="relateFlow">关联流程</el-button>
        <el-button  @click="versionManage()">版本管理</el-button>
        <el-button type="primary" @click="updateDefinition(false)">保存</el-button>
        <el-button type="primary" v-show="editable" v-if="editable" @click="updateDefinition(true)">保存并启用</el-button>
      </div>
    </div>
    <div class="clearfix"></div>

    <div id="flowLayout"  style="height:calc(100% - 40px);width:100%">
      <div class="mw-process-chart">
        <MwProcessChartEditor
          ref="processEditor"
          class="flowLayout"
          :editable="editable" :designable="designable" :observer="observer" :value="processDataGraph" />
        <div class="mw-process-chart-right">
          <div id="mw-process-chart-config">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import flowConfig from './flow-config.js'

  export default {
    name:"mw-flow-edit",
    props:{
      propAppId:String,
      propSysId:String,
      propModuleId:String,
      propAuthUnit:{
        type: Boolean,
        default: false
      }
    },
    data() {
      let appId=this.propAppId || this.$route.params.appId;
      let sysId=this.propSysId || this.$route.params.sysId;
      let moduleId=this.propModuleId || this.$route.params.moduleId;
      return {
        appId: appId,
        sysId:sysId,
        moduleId: moduleId,
        flowKeys:[],
        config:{},
        flowKey:'',//当前活动的流程KEY
        curFlowId:'',


        editable:false,
        designable:true,
        $configVue: null,

        activityTypes:[
          //"开始|start","结束|end",
          "普通|normal","串行|serial","并行|parallel","子流程|sub-proc","传阅|circular","自由节点|dynamic"
          //,"串行分支|fork-serial","并行分支|fork-parallel","分支聚合|fork-join"
        ],

        observer: this,
        flowBar: false, //版本管理工具条
        enableFlowBtn: false,

        curVersion: 0,//当前显示的版本
        curStatus: 0,//当前状态
        selVersion: 0,
        selStatus: 0,
        processList: [],
        processData: undefined,
        processDataGraph: undefined,
        pd: {},
        gridData: [],
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px',
        domLoaded: false,

        noNewVersion:false,

        footerButton: [{
          label: '添加新版本',
          func: this.addNewVersion
        }, {
          label: '编辑',
          type: 'default',
          func: this.editProcess
        }, {
          label: '启用',
          type: 'default',
          func: this.enableProcess
        }, {
          label: '删除',
          type: 'default',
          func: this.deleteProcess
        },{
          label: '回收站',
          type: 'default',
          func: this.recycleBinManager
        }],
        processDelList:[],
        selDelVersion: 0,
        selDelStatus: 0,
        recycleBinFooterButton:[
          {
            label: '恢复',
            func: this.recoverProcess
          },
          {
            label: '彻底删除',
            type: 'default',
            func: this.cascadeDeleteProcess
          },{
            label: '返回',
            type: 'default',
            func: this.returnVersionManager
          }
        ],
        relationFlowName:''
      };
    },

    computed: {

    },
    mounted() {
      let me = this;
      me.loadModuleFlowConfig(null,null)
    },
    beforeDestroy() {
      if(this.$configVue)
        this.$configVue.$destroy(true)
    },
    methods: {

      createNewFlow(){
        let me=this;
        me.mwConfirm('确定创建新流程？').then(() => {
        /*  me.formId='';
          me.formData={};
          me.mwApi.app.saveModuleSet({attr:{formId:''}},me.moduleId, me.appId).then((res) => {
            me.loadForm();
          });*/
        }).catch(() => {});
      },

      relateFlow(){
        let me=this;
        let checkRoleIds=[];
        if(me.flowKeys){
          checkRoleIds = me.flowKeys;
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listAppMoudleTree"),treeDefaultParams: {sysId:me.sysId,category:'module_flow'}
          ,size:'small_large',showTreeToolbar:false,defaultPercent:50,
          selectFirst: true,asyncLoadOnce:true, clearBtn: false, title: '选择流程', changed: function (data) {
            this.defaultParams = {applicationId:data.id};
          }, api: 'process.listLatestDefinition', singleSelect: true,columns: [{type: 'selection'},
            {prop: 'name', label: '名称', tooltip: true}],
        }, function (res) {
          if (res && res.length > 0) {
            me.flowKey = res[0].key;
            let flowName=res[0].name
            me.mwApi.app.relateFlow(me.flowKey,flowName, me.moduleId, me.appId).then((res) => {

              if (!res.result.success) {
                me.mwMsg('warning', res.result.msg);
                return;
              }
              me.relationFlowName =flowName;
              me.loadModuleFlowConfig(me.flowKey, res.version);
            })
          }
        });


      },
      delRelatedFlow(){
        let me=this;
        me.mwApi.app.delRelateFlow(me.flowKey,me.moduleId,me.appId).then((res) => {
          me.loadModuleFlowConfig(null,null);
        })
      },
      loadModuleFlowConfig(flowKey,version){
        let me = this;
        me.mwApi.app.getModuleFlowConfig(flowKey , me.moduleId, me.appId).then((res) => {
          me.config=res.result;
          me.flowKey=me.config.flowKey;
          me.relationFlowName=me.config.relationFlowName||"";
          me.flowLayOut(version);
        })
      },

      //添加新版本
      addNewVersion() {
        let me = this;
        let params = {appId: me.appId,moduleId: me.moduleId,key:me.flowKey,fromVersion: me.selVersion};
        this.mwApi.process.createDefinition(params).then((data) => {
          me.loadModuleFlowConfig(me.flowKey,data.result.newVersion);
          me.mwRef('flowVersionDialog').hide();
        });
      },

      //标记删除流程版本
      deleteProcess() {
        let me = this;
        if (me.selStatus == 1) {
          me.mwMsg('warning', '启用版本无法删除');
          return;
        }
        if (me.selStatus == 2) {
          me.mwMsg('warning', '历史版本无法删除');
          return;
        }
        if (me.processList.length == 1) {
          me.mwMsg('warning', '无法删除,至少保留一个版本');
          return;
        }
        me.mwConfirm('确定要删除此流程版本？').then(() => {
          let params = {appId: me.appId, key: me.flowKey, version: me.selVersion}
          this.mwApi.process.removeDefinition(params).then((data) => {
            this.mwApi.process.listExclusiveMarkDeletedDefinition(me.appId, me.flowKey).then((data) => {
              me.processList = data.result;
              me.mwMsg('删除成功');
              let version = me.processList[0].version;
              let status = me.processList[0].status;
              if (me.curVersion == me.selVersion) {
                me.curVersion = version;
                me.curStatus = status;
                me.flowLayOut(version);
              }
              me.selVersion = version;
              me.selStatus = status;
            });
          });
        }).catch(() => {});
      },
      //编辑流程版本
      editProcess() {
        let me = this;
        me.curVersion = me.selVersion;
        me.curStatus = me.selStatus;
        me.mwRef('flowVersionDialog').hide();
        me.flowLayOut(me.selVersion);
      },

      //选中流程版本
      selectVersion(version, status) {
        let me = this;
        me.selVersion = version;
        me.selStatus = status;
      },

      //启用流程版本
      enableProcess() {
        var me = this;
        me.mwConfirm('启用此流程版本后，新提交的数据将按照此版本流转。流程启用后将无法转回设计状态，不能对节点以及连接线做增删改？').then(() => {
          let params = {appId: me.appId, key: me.flowKey, version: me.selVersion}
          this.mwApi.process.enableDefinition(params).then((data) => {
              me.processList = data.result;
              if(me.selVersion==me.curVersion){
                me.flowLayOut(me.selVersion);
                me.mwRef('flowVersionDialog').hide()
              }
              me.mwMsg('启用成功');
          });
        }).catch(() => {

        });
      },

      //流程管理列表
      versionManage() {
        let me = this;
        this.mwApi.process.listExclusiveMarkDeletedDefinition(me.appId, me.flowKey).then((data) => {
          me.processList = data.result;
          me.mwRef('flowVersionDialog').show();
          me.mwRef('flowRecycleBinDialog').hide();
        });
      },
      //回收站
      recycleBinManager(){
        let me = this;
        this.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then((data) => {
          me.processDelList = data.result;
          me.mwRef('flowVersionDialog').hide();
          me.mwRef('flowRecycleBinDialog').show();
        });
      },
      //选中标记删除的流程版本
      selectDelVersion(version, status) {
        let me = this;
        me.selDelVersion = version;
        me.selDelStatus = status;
      },
      //彻底删除
      cascadeDeleteProcess() {
        let me = this;
        if(me.selDelVersion==0){
            me.mwMsg('warning', '请选择一个流程版本');
            return;
        }
        me.mwConfirm('删除后无法恢复，确定要彻底删除流程版本('+me.selDelVersion+'.0)？').then(() => {
          let params = {appId: me.appId, key: me.flowKey, version: me.selDelVersion, cascade:true}
          this.mwApi.process.removeDefinition(params).then((data) => {
            this.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then((data) => {
              me.processDelList = data.result;
              me.mwMsg('删除成功');
              if(me.processDelList && me.processDelList.length> 0){
                let version = me.processDelList[0].version;
                let status = me.processDelList[0].status;
                me.selDelVersion = version;
                me.selDelStatus = status;
              }else{
                me.selDelVersion = 0;
              }
            });
          });
        }).catch(() => {});
      },
      //恢复
      recoverProcess(){
        let me = this;
        if(me.selDelVersion==0){
            me.mwMsg('warning', '请选择一个流程版本');
            return;
        }
        me.mwConfirm('确定要恢复流程版本('+me.selDelVersion+'.0)？').then(() => {
          let params = {appId: me.appId, key: me.flowKey, version: me.selDelVersion}
          this.mwApi.process.recoverDefinition(params).then((data) => {
            this.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then((data) => {
              me.processDelList = data.result;
              me.mwMsg('恢复成功');
              if(me.processDelList && me.processDelList.length> 0){
                let version = me.processDelList[0].version;
                let status = me.processDelList[0].status;
                me.selDelVersion = version;
                me.selDelStatus = status;
              }else{
                me.selDelVersion = 0;
              }
            });
          });
        }).catch(() => {});
      },
      //返回版本管理
      returnVersionManager(){
         let me = this;

         me.versionManage();
      },
      //更新定义数据
      async updateDefinition(flag) {
        let me = this;

        let data ={};

        let processData=this.processData.data;

        data.graph=this.mwRef('processEditor').getData();

        var activities=[];
        for (var i = 0; i < data.graph.activity.length; i++) {
          activities.push(data.graph.activity[i].id);
        }

        var sequences=[];
        for (var i = 0; i < data.graph['sequence-flow'].length; i++) {
          sequences.push(data.graph['sequence-flow'][i].id);
        }

        let items = processData.items
        if(items.activity){
          delete items.activity
        }
        if(items['sequence-flow']){
          delete items['sequence-flow']
        }
        if (items.ACTIVITY) {
          var activity;
          var noActivity=[];
          for (var i = 0; i < items.ACTIVITY.length; i++) {
            activity = items.ACTIVITY[i];
            if(!(activities.indexOf(activity.id)>-1)){
              noActivity.push(activity.id);
              continue;
            }

            activity.name = activity.parameters.name;
            if(activity.parameters.type)
              activity.extends = activity.parameters.type;
          }
          for (var i = 0; i < noActivity.length; i++) {
            for (var j = 0; j < items.ACTIVITY.length; j++) {
              activity = items.ACTIVITY[j];
              if(noActivity[i]==activity.id){
                items.ACTIVITY.splice(j, 1);
                break;
              }
            }
          }

        }

        if (items['SEQUENCE-FLOW']) {
          var sequence;
          var noSequence=[];
          for (var i = 0; i < items['SEQUENCE-FLOW'].length; i++) {
            sequence = items['SEQUENCE-FLOW'][i];
            if(!(sequences.indexOf(sequence.id)>-1)){
              noSequence.push(sequence.id);
              continue;
            }
            sequence.name=sequence.parameters.name;
            sequence.sourceId=sequence.parameters.from;
            sequence.targetId=sequence.parameters.to;
            sequence.type = sequence.parameters.type;
            sequence.tip = sequence.parameters.tip;
          }

          for (var i = 0; i < noSequence.length; i++) {
            for (var j = 0; j < items['SEQUENCE-FLOW'].length; j++) {
              sequence = items['SEQUENCE-FLOW'][j];
              if(noSequence[i]==sequence.id){
                items['SEQUENCE-FLOW'].splice(j, 1);
                break;
              }
            }
          }
        }

        data['items'] = processData.items;
        data['name'] = processData.parameters.name || '新建流程';
        data['subProcess'] = processData.parameters.subProcess;
        data['parameters'] = processData.parameters;

        let newObj=me.config.attr.flow.versions.length>0 ? false : true;

        if(me.noNewVersion){
          newObj=false;
        }

        var parameters=data.parameters;

        if(parameters){
          var config=me.config.fieldMapping;

          var businessName=parameters.businessName===undefined?'':parameters.businessName;

          var businessKeyword=parameters.businessKeyword===undefined?'':parameters.businessKeyword;

          var businessCategory=parameters.businessCategory===undefined?'':parameters.businessCategory;

          var urgencyLevel=parameters.urgencyLevel===undefined?'':parameters.urgencyLevel;

          var businessField0 = parameters.businessField0===undefined?'':parameters.businessField0;

          var businessField1 = parameters.businessField1===undefined?'':parameters.businessField1;

          let flag=false;
          let fieldMapping ={};
          if(businessName){
            fieldMapping.businessName=businessName;
          }
          if(businessKeyword){
            fieldMapping.businessKeyword=businessKeyword;
          }
          if(businessCategory){
            fieldMapping.businessCategory=businessCategory;
          }
          if(urgencyLevel){
            fieldMapping.urgencyLevel=urgencyLevel;
          }
          if(businessField0){
            fieldMapping.businessField0=businessField0;
          }
          if(businessField1){
            fieldMapping.businessField1=businessField1;
          }
          if(businessName!=(config.businessName===undefined?'':config.businessName)){
            flag=true;
          }
          if(!flag &&businessKeyword!=(config.businessKeyword===undefined?'':config.businessKeyword)){
            flag=true;
          }
          if(!flag &&businessCategory!=(config.businessCategory===undefined?'':config.businessCategory)){
            flag=true;
          }
          if(!flag &&urgencyLevel!=(config.urgencyLevel===undefined?'':config.urgencyLevel)){
            flag=true;
          }
          if(!flag &&businessField0!=(config.businessField0===undefined?'':config.businessField0)){
            flag=true;
          }
          if(!flag &&businessField1!=(config.businessField1===undefined?'':config.businessField1)){
            flag=true;
          }
          if(flag){
            me.mwApi.app.saveFieldMapping({fieldMapping:fieldMapping},me.moduleId, me.appId).then((res) => {
              me.config.fieldMapping=fieldMapping;
            });
          }
        }

        let params = {
          owner:me.sysId,
          appId: me.appId,
          moduleId: me.moduleId,
          key:me.flowKey,
          $newObj:newObj,
          version:me.curVersion,
          flows: data,
          publish: flag
        };

        this.mwApi.process.updateDefinition(params).then((data) => {
          me.noNewVersion=true;
          if (flag) {
            me.mwMsg('发布成功');
            me.loadModuleFlowConfig(me.flowKey,me.curVersion);
          } else {
            me.mwMsg('保存成功');
          }
        }).catch(reason => console.error(reason));
      },


      flowLayOut(version) {
        let me = this,attr=me.config.attr;

        let versions = attr.flow.versions;
        if (version) {
          me.curVersion = version;
        } else {
          me.curVersion = attr.flowVer || (versions.length > 0 ? versions[versions.length - 1].ver : 1);
        }
        me.flowData(me.curVersion , versions);
      },


      //加载流程数据
      flowData(version,versions) {
        let me = this;
        if (version == 1 && versions.length == 0) {
          me.selVersion = 1;
          me.editable=true;
          me.flowChart({name:me.config.moduleName});
        } else {
          let params = {appId: me.appId, key: me.flowKey, version: version};
          this.mwApi.process.getDefinition(params).then((data) => {
            if (data.result.editable) {
              me.editable=true;
            } else {
              me.editable=false;
            }
            me.curStatus = data.result.flows.status;
            me.selVersion = data.result.flows.version;
            me.selStatus = data.result.flows.status;

            me.flowChart(data.result.flows);
          });
        }
      },
      //加载流程图
      flowChart(data) {
        let me = this;

        if (!data.items) {
          data.items = {};
        }

        if (!data.parameters) {
          //data.parameters={};
        }

        if (!data.items.ACTIVITY) {
          data.items.ACTIVITY = []
          /*data.items.ACTIVITY.push({
            id: 'start',
            name: '开始',
            extends: 'start',
            parameters: {id: 'start', name: '开始',type:'start'}
          })
          data.items.ACTIVITY.push({
            id: 'end',
            name: '结束',
            extends: 'end',
            parameters: {id: 'end', name: '结束',type:'end'}
          })*/
        }

        if (!data.items['SEQUENCE-FLOW']) {
          data.items['SEQUENCE-FLOW'] = []
        }

        if (this.$configVue) {
          this.$configVue.$destroy(true);
          this.$configVue=null;
        }

        this.loadFlowConfig(Vue,me,data && data.items && {data});
      },

      loadFlowConfig(Vue,parent,_data) {
        let me = this;

          var data=me.config.flowConfig;

          if(!_data.data.parameters){
            _data.data.parameters={id:_data.data.id,name:_data.data.name}
          }
          this.processData=_data;

          this.processDataGraph=_data.data.graph;

          if (false) {

            var components =[];

            var event = 'parent.$configVue =' + data.eventScript;

            var script = data.baseScript.replace('$obj', 'var backdrop').replace('$template', data.baseTemplate.replace(/\n/g, '').replace(/'/g, '\\\''))+"\n";
            components.push("'backdrop':backdrop");

            var nodes=[]

            if(data.nodeList){
              data.nodeList.forEach((v)=>{
                script+=v.script.replace('$obj', 'var node_'+v.code.replace(/-/g, '_')).replace('$template', v.template.replace(/\n/g, '').replace(/'/g, '\\\''))+"\n";
                components.push("'node-"+v.code.replace(/-/g, '-')+"'"+':node_'+v.code.replace(/-/g, '_'));
                nodes.push(v.name+"|"+v.code.replace(/-/g, '-'));
              })
            }

            if(data.lineList){
              data.lineList.forEach((v)=>{
                script+=v.script.replace('$obj', 'var line_'+v.code.replace(/-/g, '_')).replace('$template', v.template.replace(/\n/g, '').replace(/'/g, '\\\''))+"\n";
                components.push("'line-"+v.code.replace(/-/g, '-')+"'"+':line_'+v.code.replace(/-/g, '_'));
              })
            }
            script=script+event.replace('$components',components.join(","));

            me.activityTypes=nodes

            eval(script);
          } else {
            new flowConfig(Vue,me,_data)
          }

      }
    },
    errorCaptured(err, component, info) {
      console.error(err);
    }
  };


</script>



// WEBPACK FOOTER //
// src/modules/index/views/formEdit/flow/Flow.vue